export enum LocationTypeType {
  REGULAR = 'REGULAR',
  SUITE = 'SUITE',
}
